import { useMutation, useQueryClient } from "@tanstack/react-query";
import { jwtDecode } from "jwt-decode";
import { api, clearOnboardingAccessToken } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";
import { useAuth } from "@contexts/auth";

export const useSetOnboardingPassword = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();
  const { setToken, setUsername, setEmail, setFullName, setId, setRoles, setOnboardingStatus } = useAuth();

  return useMutation({
    mutationFn: (passwordData: { password: string }) =>
      api.post(`onboarding/session/me/set-password`, passwordData),
    onSuccess: (res: any) => {
      const accessToken = res.data.access_token;
      const decoded: any = jwtDecode(accessToken);

      clearOnboardingAccessToken();
      setToken(accessToken);
      setId(decoded.id);
      setFullName(decoded.full_name);
      setUsername(decoded.username);
      setEmail(decoded.email);
      setRoles(decoded.roles);
      setOnboardingStatus(decoded.onboarding_status || "approved");

      queryClient.setQueryData(onboardingQKeys.session(), { data: res.data.session });
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
    },
    onError: (res: any) => {
      console.error("[From Set Onboarding Password]", res);
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.session() });
      handleErrors(res, "mutation");
    },
  });
};
